import {routerReducer, RouterReducerState} from '@ngrx/router-store';
import {leftPanelReducer, LeftPanelState} from '@store/left-panel/reducer';
import {rightsReducer, RightsState} from '@store/rights/reducer';
import {CtsDistributionState, ctsDistributionStateReducer} from '@store/cts-distribution/reducer';

/** Auxiliary 'reducers' variable.' */
export const reducers = {
	router: routerReducer,
	leftPanel: leftPanelReducer,
	rights: rightsReducer,
	ctsDistribution: ctsDistributionStateReducer,
};

/**
 * Auxiliary store state interface declaration.
 */
export interface AppState {
	/** {RouterReducerState} router */
	router: RouterReducerState;
	/** {LeftPanelState} leftPanel */
	leftPanel: LeftPanelState;
	/** {RightsState} rights */
	rights: RightsState;
	/** {CtsDistributionState} ctsDistribution */
	ctsDistribution: CtsDistributionState;
}
